/**
 * お気に入り（いいね）機能
 * ProductHistoryと連携してローカルストレージに商品情報を保存
 */

class ProductFavorite {
  constructor() {
    this.init();
  }

  init() {
    // お気に入りボタンを取得
    const favoriteButtons = document.querySelectorAll('.product__favorite-btn');

    favoriteButtons.forEach(button => {
      const productHandle = button.dataset.productHandle;
      const productData = {
        handle: productHandle,
        id: button.dataset.productId,
        title: button.dataset.productTitle,
        price: button.dataset.productPrice,
        image: button.dataset.productImage,
        url: button.dataset.productUrl
      };

      // 初期状態を設定
      if (typeof ProductHistory !== 'undefined' && ProductHistory.isLiked(productHandle)) {
        button.classList.add('is-active');
        button.setAttribute('aria-label', 'お気に入りから削除');
      }

      // クリックイベントを追加
      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleFavorite(button, productData);
      });
    });
  }

  // お気に入りの切り替え
  toggleFavorite(button, productData) {
    if (typeof ProductHistory === 'undefined') {
      console.error('ProductHistory is not loaded');
      return;
    }

    const isNowLiked = ProductHistory.toggleLike(productData);

    if (isNowLiked) {
      button.classList.add('is-active');
      button.setAttribute('aria-label', 'お気に入りから削除');
      this.showNotification('お気に入りに追加しました');
    } else {
      button.classList.remove('is-active');
      button.setAttribute('aria-label', 'お気に入りに追加');
      this.showNotification('お気に入りから削除しました');
    }
  }

  // 通知を表示
  showNotification(message) {
    // 既存の通知を削除
    const existing = document.querySelector('.favorite-notification');
    if (existing) existing.remove();

    // 通知要素を作成
    const notification = document.createElement('div');
    notification.className = 'favorite-notification';
    notification.textContent = message;
    document.body.appendChild(notification);

    // アニメーション
    setTimeout(() => notification.classList.add('is-visible'), 10);
    setTimeout(() => {
      notification.classList.remove('is-visible');
      setTimeout(() => notification.remove(), 300);
    }, 2000);
  }
}

// DOMが読み込まれたら初期化
document.addEventListener('DOMContentLoaded', () => {
  new ProductFavorite();
});
